import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';

import { AuthService } from '../auth/auth.service';
import type { Role } from '../../models/auth.model';

export const roleGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const requiredRoles = (route.data['roles'] as Role[] | undefined) ?? [];
  if (requiredRoles.length === 0) {
    return true;
  }

  if (requiredRoles.some((role) => auth.hasRole(role))) {
    return true;
  }

  return router.createUrlTree(['/403']);
};
